import {
  REPORTS_SHIFTS_SET_SHIFT_SUMMARY,
  REPORTS_SHIFTS_SET_LIST_SHIFT,
  REPORTS_SHIFTS_LIST_SHIFT_REQUEST,
  REPORTS_SHIFTS_SHIFT_SUMMARY_REQUEST,
  REPORTS_SHIFTS_SET_START_END_DATE,
  REPORTS_SHIFTS_PAGE_REQUEST,
  REPORTS_SHIFTS_CHANGE_DATE,
  REPORTS_SHIFTS_EXPORT_SHIFT_REQUEST,
  REPORTS_SHIFTS_DETAILS_REQUEST,
  REPORTS_SHIFTS_SET_SHIFT_DETAILS,
  REPORTS_SHIFTS_CHANGE_OUTLET,
  REPORTS_SHIFTS_DETAIL_HIDE,
  REPORTS_SHIFTS_SET_OUTLETS,
  REPORTS_SHIFTS_SUMMARY_LOAD_MORE_DATA,
  REPORTS_SHIFTS_SET_CURRENT_PAGE
} from './constants'

/****************************************
 * Request
 ****************************************/

export function shiftSummaryRequest (query) {
  return {type: REPORTS_SHIFTS_SHIFT_SUMMARY_REQUEST, payload: {query}}
}

export function listShiftRequest (query) {
  return {type: REPORTS_SHIFTS_LIST_SHIFT_REQUEST, payload: {query}}
}

export function pageRequest () {
  return {type: REPORTS_SHIFTS_PAGE_REQUEST, payload: {}}
}

export function shiftSummaryLoadMoreData (query, previousShift) {
  return {type: REPORTS_SHIFTS_SUMMARY_LOAD_MORE_DATA, payload: {query, previousShift}}
}

/**
 *
 * @param {start,end} query
 * @param {string} filename to be matched against get profile
 * @param {int} outletId the exported outlet id. If you select 'all outlet', then specify the first outlet
 * @return {{type, payload: {query: *, filename: *}}}
 */
export function exportShiftRequest (query, filename, outletId) {
  return {type: REPORTS_SHIFTS_EXPORT_SHIFT_REQUEST, payload: {query, filename, outletId}}
}

export function shiftDetailsRequest (query, isMobile) {
  return {type: REPORTS_SHIFTS_DETAILS_REQUEST, payload: {query, isMobile}}
}

export function hideShiftDetail (isMobile) {
  return {type: REPORTS_SHIFTS_DETAIL_HIDE, payload: {isMobile}}
}

/****************************************
 * Change handler
 ****************************************/
export function changeDate (startDate, endDate, isMobile) {
  return {type: REPORTS_SHIFTS_CHANGE_DATE, payload: {startDate, endDate, isMobile}}
}

export function changeOutletShift (outletIds, startDate, endDate, isMobile) {
  return {type: REPORTS_SHIFTS_CHANGE_OUTLET, payload: {outletIds, startDate, endDate, isMobile}}
}

export function setCurrentPage (page) {
  return {type: REPORTS_SHIFTS_SET_CURRENT_PAGE, payload: {page}}
}

/****************************************
 * Setter of items
 ****************************************/

export function setShifts (shifts) {
  return {type: REPORTS_SHIFTS_SET_LIST_SHIFT, payload: {shifts}}
}

export function setSummary (summary) {
  return {type: REPORTS_SHIFTS_SET_SHIFT_SUMMARY, payload: {summary}}
}

export function setStartEndDate (startDate, endDate) {
  return {type: REPORTS_SHIFTS_SET_START_END_DATE, payload: {startDate, endDate}}
}

export function setShiftDetails (shiftDetails) {
  return {type: REPORTS_SHIFTS_SET_SHIFT_DETAILS, payload: {shiftDetails}}
}

export function setOutlets (outlets) {
  return {type: REPORTS_SHIFTS_SET_OUTLETS, payload: {outlets}}
}



// WEBPACK FOOTER //
// ./app/actions/reports/shifts/index.js